<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        <div class="text-left">
          <div class="card-custom-web">
            <br />
            <h4
              style="color: #000; text-align: left"
              class="sub-title-header ml-4"
            >
              Select Type
            </h4>
            <br />

            <div class="ml-4 mr-4">
            <CCard class="" @click="GoToStudent()">
              <CRow>
                <div style="width: 60%" class="float-left">
                  <h3
                    style="text-align: left; margin: 20px 30px; font-weight: 600px; color: #000;"
                    class="sub-title-header"
                  >
                    One to One
                  </h3>
                  <h3
                    style="text-align: left; margin: 20px 30px; font-weight: 400px; color: #000;"
                    class="sub-title-header"
                  >
                    Personal class with a tutor
                  </h3>
                </div>
                <div style="width: 20%" class="float-right mt-4">
                  <img src="../../assets/img/icon/classType.svg" />
                </div>
                <div style="clear:both"></div>
              </CRow>
            </CCard>

            <CCard class="" @click="GoToGroup()">
              <CRow>
                <div style="width: 60%" class="float-left">
                  <h3
                    style="text-align: left; margin: 20px 30px; font-weight: 600px; color: #000;"
                    class="sub-title-header"
                  >
                    Group of 2
                  </h3>
                  <h3
                    style="text-align: left; margin: 20px 30px; font-weight: 400px; color: #000;"
                    class="sub-title-header"
                  >
                  Create new waiting list entry
                  </h3>
                </div>
                <div style="width: 25%; margin-left: -20px;" class="float-right mt-4">
                  <img src="../../assets/img/icon/joinGp.svg" />
                </div>
                <div style="clear:both"></div>
              </CRow>
            </CCard>

            <CCard class="" @click="GoToGroupWaiting()">
              <CRow>
                <div style="width: 60%" class="float-left">
                  <h3
                    style="text-align: left; margin: 20px 30px; font-weight: 600px; color: #000;"
                    class="sub-title-header"
                  >
                    Waiting List
                  </h3>
                  <h3
                    style="text-align: left; margin: 20px 30px; font-weight: 400px; color: #000;"
                    class="sub-title-header"
                  >
                  Find your partner in waiting list
                  </h3>
                </div>
                <div style="width: 25%; margin-left: -20px;" class="float-right mt-4">
                  <img src="../../assets/img/icon/partner.png" style="max-width:100%"/>
                </div>
                <div style="clear:both"></div>
              </CRow>
            </CCard>
            </div>
           
          </div>
        </div>
      </div>
      <MainlayoutBottom></MainlayoutBottom>
    </CContainer>
    <div class="header-top">Class Type</div>
    <div class="header-left">
      <img src="../../assets/img/icon/VectorLeft.svg" @click="GoBack()"/>
    </div>
    <div class="header-right">
      <span @click="GoHomePage()"><CIcon name="cil-home"/></span>
      <br />
      
    </div>
    <div style="clear: both"></div>
  </div>
</template>

<script>
import MainlayoutBottom from "../../containers/TheBottomCustom.vue";
export default {
  components: {
    MainlayoutBottom,
  },
  methods: {
    GoHomePage() {
      this.$router.push("/ExistingUser");
    },

    GoToStudent() {
  const hasTeacherId = this.$route.query.hasOwnProperty('teacherId');

  if (hasTeacherId) {
    this.$router.push("/FindTutor/FTStudent?teacherId=" + this.$route.query.teacherId);
  } else {
    this.$router.push("/FindTutor/FTStudent");
  }
},


    GoToGroup(){
      this.$router.push(
        "/FindTutor/FTStudentGroup"
      );
    },
    GoToGroupWaiting(){
      this.$router.push(
        "/FindTutor/FTListWaiting"
      );
    },

    GoToRegStud(){
      this.$router.push(
        "/RegisterStudentGrade"
      );
    },
    GoBack() {
      this.$router.back();
    },
  }
}
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
body {
  font-family: "Montserrat", sans-serif;
}

.class-card-box {
/* White Solid AF */

background: #FFFFFF;

  box-shadow: -5px 8px 20px -1px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}

</style>